window.$ = window.jQuery = require('jquery');
require('bootstrap/dist/css/bootstrap.css');
require('./styles/bootstrap-cov.css');
require('bootstrap');
require('font-awesome/css/font-awesome.css');
require('admin-lte/dist/css/AdminLTE.css');
require('admin-lte/dist/css/skins/_all-skins.css');
require('./styles/adminlte-cov.css');
require('./styles/_all-skins-cov.css');
require('admin-lte/plugins/slimScroll/jquery.slimscroll.min');
require('admin-lte');
//require('./plugins/theme-setting/theme-setting');
require('./plugins/contabs/contabs.css');
require('./plugins/contabs/contabs.min');
require('./plugins/waves/waves');
require('./styles/waves-cov.css');
require('animate.css/animate.css');
require('./styles/index-style.css');
require('babel-polyfill');
require('./plugins/layer/theme/default/layer.css');
import 'babel-polyfill';
const layer=require('./plugins/layer/layer');
import { accessUrlConfig } from "./config/accessUrlConfig";
import { util } from "./util/util";


/**
 *获取存于本地得json数据，开发中可能提供接口获取数据
 */

/**
 * [暂时使用sessionStorage模拟登陆效果，接口完善后，正常调用接口实现登陆并获取token]
 * @type {[function]}
 */
let sessionIsLogin = !!(sessionStorage.getItem("isLogin") == "true");
let isLogin = (sessionIsLogin == "" || sessionIsLogin == undefined || sessionIsLogin == null) ? false : sessionIsLogin;
if (!isLogin) {
  window.location.href = "pages/login-admin.html";
}

//加载首页右上角用户信息--开始 by guomh
let userNameAndRoleName = sessionStorage.getItem('username') + "（" + sessionStorage.getItem('roleName') + "）";
let userUnit = sessionStorage.getItem('userUnit');
$('#username').html('<span title=' + userNameAndRoleName + '>' + userNameAndRoleName + '</span>');
$("#userUnit").html(userUnit);
$('#username1').html(userNameAndRoleName);
$("#userUnit1").html('<small>' + userUnit + '</small>');
//加载首页右上角用户信息--结束
// 处理菜单数据 created fanxh
let menu = sessionStorage.getItem("menu"), menuConfig, menuTitleConfig, indexMenu;
if (menu) {
  let _result = handMenuData(JSON.parse(menu));
  menuConfig = _result._menuConfig;
  menuTitleConfig = _result._menuTitleConfig;
  indexMenu = _result._indexMenu;
} else {
  console.log('菜单丢失');
  window.location.href = "pages/login-admin.html";
}

/**
 * 根据数据生成首页一级菜案
 * @type {String}
 */
let indexMenuList = "";
let menuBoxes = "";


for (var key in indexMenu) {
  indexMenuList = indexMenuList + `<li data-id = ${key} >${indexMenu[key]}</li>`;
  menuBoxes = menuBoxes + `<ul class="sidebar-menu"></ul>`;
}
$(".sidebar").html(menuBoxes);
$(".seconde-header-nav").html(indexMenuList);
/**
 * [遍历json数据并调用changeHtml方法生成dom节点]
 */
for (var i = 0; i < menuConfig.length; i++) {
  for (var s in menuConfig[i]) {
    changeHtml(menuConfig[i][s], i);
  }
}


//chiefEditor总编;bigEditor大编;researcher研究人员;expert专家;counselor顾问;sysAdmin系统管理员
let userType = sessionStorage.getItem('userType');
/**
* 根据当前登录身份修改首页指向页面
* @type {[type]}
*/
if (userType == 'bigEditor') {
  $(".index").eq(0).attr("data-id", "./pages/editor-index.html");
  $(".iframe-index").eq(0).attr("data-id", "./pages/editor-index.html");
  $(".iframe-index").eq(0).attr("src", "./pages/editor-index.html");

  setTimeout(()=>{
    $('.treeview-menu li:eq(0) a').trigger("click");
    $('.sidebar-toggle').trigger("click");
    $('.page-tabs-content a:eq(0)').text('研究概况');
  },500);

} else if (userType == 'researcher') {
  $(".index").eq(0).attr("data-id", "./pages/researcher-index.html");
  $(".iframe-index").eq(0).attr("data-id", "./pages/researcher-index.html");
  $(".iframe-index").eq(0).attr("src", "./pages/researcher-index.html");
  setTimeout(()=>{
    $('.treeview-menu li:eq(0) a').trigger("click");
    $('.sidebar-toggle').trigger("click");
    $('.page-tabs-content a:eq(0)').text('研究概况');
  },500);
} else if (userType == 'ptAdmin') {
  $(".index").eq(0).attr("data-id", "./pages/core-zjjnl.html");
  $(".iframe-index").eq(0).attr("data-id", "./pages/core-zjjnl.html");
  $(".iframe-index").eq(0).attr("src", "./pages/core-zjjnl.html");
  setTimeout(()=>{
    $('.seconde-header-nav li:eq(1)').trigger("click");
    $('.sidebar-menu:eq(1) li:eq(1)>a').trigger("click");
    $('.sidebar-toggle').trigger("click");
    $('.page-tabs-content a:eq(0)').text('专家核心期刊表');
  },500);
}  else if (userType == 'counselor') {
  $(".index").eq(0).html("研究报告（2023年版）");
  $(".index").eq(0).attr("data-id", "./pages/counselor-index.html");
  $(".iframe-index").eq(0).attr("data-id", "./pages/counselor-index.html");
  $(".iframe-index").eq(0).attr("src", "./pages/counselor-index.html");

  setTimeout(()=>{
    $('.seconde-header-nav li:eq(1)').trigger("click");
    $('.sidebar-menu:eq(1) li:eq(1)>a').trigger("click");
  },500);

  setTimeout(()=>{
    $('.J_menuItem')[3].click();
  },1000);
  //$("body").eq(1).addClass('sidebar-collapse');
  // setTimeout(()=>{
  //   // $(".seconde-header-nav li").eq(1).trigger("click");
  //   $(".index").eq(0).html("研究报告（2017年版）");
  //   // $(".sidebar-menu").eq(1).add
  //   $(".sidebar-menu").eq(1).css("display", "block");
  //   $(".sidebar-menu").eq(1).siblings().css("display", "none");
  //   $("body").eq(0).addClass('sidebar-collapse');
  //   // $(".J_mainContent").append(`<iframe class="J_iframe" name="iframe1" width="100%" height="100%" src="./pages/core-journal.html" frameborder="0"
  //   //     data-id="./pages/core-journal.html" seamless=""></iframe>`);
  //   // $(".page-tabs-content").append(`<a href="javascript:;" class="active J_menuTab" data-id="./pages/core-journal.html">核心期刊表（2017年版）</a>`);
  //   $(".index").eq(0).attr("data-id", "./pages/counselor-index.html");
  //   // $(".iframe-index").eq(0).attr("style", "display: none;");
  //   // $(".index").eq(0).removeClass('active');
  //   $(".iframe-index").eq(0).attr("data-id", "./pages/counselor-index.html");
  //   $(".iframe-index").eq(0).attr("src", "./pages/counselor-index.html");
  // }, 500);

} else if (userType == 'expert') {
  util.getData(accessUrlConfig.accountExpert.getEntityByLoginName + sessionStorage.getItem('username')+`&t=${new Date().getMilliseconds()}`).then(
    (data) => {
      let _address='../index.html';
      switch (data.data.applyStatus) {
        case '1':
           _address='pages/choice-subject.html';
           window.location.href = _address;
          break;
        case '2':
           _address='pages/change-user-information.html';
           window.location.href = _address;
         break;
      }
    }
  );

  setTimeout(()=>{
    // $(".seconde-header-nav li").eq(1).trigger("click");
    $('body > div > header > nav.second-header > ul > li').attr("style", "display: none;");
    $(".index").eq(0).html("研究概况");
    // $(".sidebar-menu").eq(1).add
    $(".sidebar-menu").eq(1).css("display", "block");
    $(".sidebar-menu").eq(1).siblings().css("display", "none");
    $("body").eq(0).addClass('sidebar-collapse');
    $(".J_mainContent").append(`<iframe class="J_iframe" name="iframe1" width="100%" height="100%" src="./pages/export-rules-contents.html" frameborder="0"
        data-id="./pages/export-rules-contents.html" seamless=""></iframe>`);
    $(".page-tabs-content").append(`<a href="javascript:;" class="active J_menuTab" data-id="./pages/export-rules-contents.html">专家评审原则及内容</a>`);

    $(".J_mainContent").append(`<iframe class="J_iframe" name="iframe2" width="100%" height="100%" src="./pages/export-guides.html" frameborder="0"
    data-id="./pages/export-guides.html" seamless=""></iframe>`);
$(".page-tabs-content").append(`<a href="javascript:;" class="active J_menuTab" data-id="./pages/export-guides.html">专家操作指南</a>`); 

    $(".J_mainContent").append(`<iframe class="J_iframe" name="iframe3" width="100%" height="100%" src="./pages/expert-nature-evaluate.html" frameborder="0"
    data-id="./pages/expert-nature-evaluate.html" seamless=""></iframe>`);
$(".page-tabs-content").append(`<a href="javascript:;" class="active J_menuTab" data-id="./pages/expert-nature-evaluate.html">专家定性评价</a>`);
    $(".index").eq(0).attr("data-id", "./pages/expert-index.html");
    $(".J_iframe").eq(0).attr("style", "display: none;");
    $(".J_iframe").eq(1).attr("style", "display: none;");
    $(".J_iframe").eq(2).attr("style", "display: none;");
    $(".index").eq(0).removeClass('active');
    $("#page-wrapper > div.row.content-tabs > nav > div > a:nth-child(2)").removeClass('active');
    $("#page-wrapper > div.row.content-tabs > nav > div > a:nth-child(3)").removeClass('active');
    $(".iframe-index").eq(0).attr("data-id", "./pages/expert-index.html");
    $(".iframe-index").eq(0).attr("src", "./pages/expert-index.html");
  }, 500);
}



/**
 * [根据json数据生成并返回html节点]
 * @param  {[array]} m [请求获得或从本地读取得列表json数据]
 * @param  {[number]} a [索引]
 * @return {[dom]}   [返回得html节点]
 */
function changeHtml(m, a) {
  let len = m.length;
  let menuHtml = '';
  for (var i = 0; i < len; i++) {
    menuHtml = menuHtml + `<li class="treeview"> \
        <a href="#"><i class="fa fa-link"></i><span>${m[i].menuName}</span>\
            <span class="pull-right-container">\
                    <i class="fa fa-angle-left pull-right"></i>\
                </span>\
        </a>\
        <ul class="treeview-menu">`;
    let listLen = m[i].menuList.length;
    let listMenu = '';
    for (var j = 0; j < listLen; j++) {
      listMenu = listMenu + `<li><a href="${m[i].menuList[j].url}" class="J_menuItem">${m[i].menuList[j].name}</a></li>`;
    }
    menuHtml = menuHtml + listMenu + '</ul></li>';
  }
  menuHtml = menuHtml + '</ul>';
  let titleHtml = `<li><a class="J_menuItem menu-title ">${menuTitleConfig[a]}</a></li>`;

  menuHtml = titleHtml + menuHtml;
  $(".sidebar-menu").eq(a).html(menuHtml);
}



/**
 * tab切换效果实现
 */
$(".seconde-header-nav li").click(function () {
  $(".J_tabCloseAll").click();

  let _index = $(".seconde-header-nav li").index($(this));
  //add by fanxh 如果是专家登陆，点击期刊评价管理时，弹出专家定性评价页 2018/5/26 begin
  if (userType == 'expert' && _index==1){
    $('.treeview-menu li:eq(2) a').trigger("click");
    $('.sidebar-toggle').trigger("click");
  }
  //add by fanxh 如果是专家登陆，点击期刊评价管理时，弹出专家定性评价页 2018/5/26 end
  $(".sidebar-menu").eq(_index).css("display", "block");
  $(".sidebar-menu").eq(_index).siblings().css("display", "none");
});



$(".J_tabExit").click(() => {
  var loginUrl = '';
  if (sessionStorage.getItem('userType') === 'expert') {
    util.getData(accessUrlConfig.expertNatureEval.querySubmit).then(
      data => {
        if(data.data.startsWith("“")){
          layer.confirm("您尚未提交"+data.data.split(";")[0]+"确认要退出系统吗？", {title:'退出系统',
            btn: ['确认退出','继续评审'] //按钮
          }, function(){
             loginUrl = './pages/login-expert.html';
             loginout(loginUrl);
          });
        }else{
          loginUrl = './pages/login-expert.html';
          loginout(loginUrl);
        }
      }
    );
  } else {
    loginUrl = './pages/login-admin.html';
    loginout(loginUrl);
  }
});

$('.treeview .J_menuItem').click(() => {
  let _sessionIsLogin = !!(sessionStorage.getItem("isLogin") == "true");
  let _isLogin = (_sessionIsLogin == "" || _sessionIsLogin == undefined || _sessionIsLogin == null) ? false : _sessionIsLogin;
  if (!_isLogin) {
    alert("登录失效，请重新登录");
    window.location.href = "pages/login-admin.html";
  }
});

$(".seconde-header-nav").on('click', 'li', function() {
  let _roleName = sessionStorage.getItem('roleName');
  if (_roleName == "大编" || _roleName == "研究人员") {
    let _index = $(this).index();
    let _current = $(".sidebar-menu").eq(_index).find(".treeview")[0];
    $(_current).addClass('active');
    $(_current).find(".treeview-menu").addClass('menu-open');
    $(_current).find(".treeview-menu a")[0].click();
  }
});

//处理数据，并生生相应格式的数据
function handMenuData(data) {

  let _indexMenu = {};
  let _menuConfig = [];
  let _menuTitleConfig = [];
  for (var index in data) {
    let _firstMenuName = data[index].name;   //一级菜单的名字
    let _firstMenuCode = data[index].code;   //一级菜单的编码
    let _secondMenuList = [];                //二级菜单的数组列表{name:'',url:''}格式
    let _menuConfigItem = {};

    _indexMenu[_firstMenuCode] = _firstMenuName;
    _menuTitleConfig.push(_firstMenuName);

    data[index].children.forEach(element => {
      _secondMenuList.push({
        name: element.name,
        url: element.pageName
      });
    });
    _menuConfigItem[data[index].code] = [
      {
        menuName: data[index].name,
        menuList: _secondMenuList
      }
    ];
    _menuConfig.push(_menuConfigItem);

  }

  return {
    _menuTitleConfig, _indexMenu, _menuConfig
  };
}

/**
 * 根据用户类型，判断登陆地址
 * @author fanxh
 */
function loginout(loginUrl) {
  sessionStorage.setItem("isLogin", false);
  sessionStorage.removeItem('token');
  //add by guomh 2017-12-25 退出登录清除一些session  begin
  sessionStorage.removeItem('adminId');
  sessionStorage.removeItem('dictionary');
  sessionStorage.removeItem('menu');
  sessionStorage.removeItem('okapiUserId');
  sessionStorage.removeItem('permissions');
  sessionStorage.removeItem('roleName');
  sessionStorage.removeItem('userId');
  sessionStorage.removeItem('userUnit');
  sessionStorage.removeItem('username');
  sessionStorage.removeItem('userType');
  window.location = loginUrl;
  //add by guomh 2017-12-25 退出登录清除一些session  end
}



// WEBPACK FOOTER //
// src/index.js